import React, {type ReactElement} from 'react';
import {Key} from 'components/Key';
import {toggleSymbol} from 'ui/keyboard';
import {useDispatch} from 'ui/store';
import {InputMode, isSpend, updateMode, useInputMode} from 'store/UserInput';
import {compose} from 'shared/utils/compose';

function selectMode(currentMode: UserInputMode): UserInputMode {
  return isSpend(currentMode) ? InputMode.Income : InputMode.Spend;
}

export const ModeToggle = (): ReactElement => {
  const inputMode = useInputMode();
  const futureMode = selectMode(inputMode);
  const update = useDispatch(updateMode, futureMode);

  return <Key symbol={toggleSymbol} onPress={compose(update)} />;
};
